import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

const inp = "w-full px-5 py-4 rounded-2xl border-2 border-[var(--agt-line)] bg-white focus:outline-none focus:border-[var(--agt-mustard)] focus:ring-2 focus:ring-[var(--agt-mustard)]/20 transition-colors text-base font-medium";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success("Connexion réussie");
      nav(u.role === "admin" ? "/admin" : "/");
    } catch {
      toast.error("Identifiants invalides");
    } finally { setBusy(false); }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <span className="eyebrow">Bon retour</span>
      <h1 className="font-heading mt-4 text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.5rem, 6vw, 3.5rem)" }}>Connexion.</h1>
      <p className="mt-4 text-lg text-[var(--agt-ink-muted)]">Accédez à votre espace.</p>
      <form onSubmit={onSubmit} className="mt-10 grid gap-4">
        <input required type="email" placeholder="Email" data-testid="login-email" className={inp} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}/>
        <input required type="password" placeholder="Mot de passe" data-testid="login-password" className={inp} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}/>
        <button disabled={busy} className="btn-primary justify-center" data-testid="login-submit">{busy ? "..." : "Se connecter"}</button>
      </form>
      <p className="mt-8 text-base text-[var(--agt-ink-muted)]">Pas encore de compte ? <Link to="/inscription" className="text-[var(--agt-mustard-deep)] font-bold">S'inscrire</Link></p>
    </main>
  );
}

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(f.email, f.password, f.name);
      toast.success("Compte créé !");
      nav("/abonnement");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <span className="eyebrow">Bienvenue</span>
      <h1 className="font-heading mt-4 text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.5rem, 6vw, 3.5rem)" }}>Créer un compte.</h1>
      <p className="mt-4 text-lg text-[var(--agt-ink-muted)]">Rejoignez la communauté pour référencer votre boutique.</p>
      <form onSubmit={onSubmit} className="mt-10 grid gap-4">
        <input required placeholder="Nom / boutique" data-testid="register-name" className={inp} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })}/>
        <input required type="email" placeholder="Email" data-testid="register-email" className={inp} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}/>
        <input required type="password" placeholder="Mot de passe" data-testid="register-password" className={inp} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}/>
        <button disabled={busy} className="btn-primary justify-center" data-testid="register-submit">{busy ? "..." : "Créer mon compte"}</button>
      </form>
      <p className="mt-8 text-base text-[var(--agt-ink-muted)]">Déjà inscrit ? <Link to="/connexion" className="text-[var(--agt-mustard-deep)] font-bold">Se connecter</Link></p>
    </main>
  );
}
